import { LightbulbIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyInsightsProps {
  onCreate: () => void;
}

export const EmptyInsights = ({ onCreate }: EmptyInsightsProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <LightbulbIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('insights.empty_state_title')}</EmptyTitle>
        <EmptyDescription>{t('insights.empty_state_description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onCreate}>
          <PlusIcon size={16} />
          {t('common.create')}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
